import Vue from "vue";
import Vuex from "vuex";
import ActivitiesModule from "../store/modules/activities.js";
import UploadModule from "./modules/upload";
import UserModule from "./modules/user";
import VuexPersist from "vuex-persist";
const firebase = require("../../firebase.config.js");

Vue.use(Vuex);

const vuexLocal = new VuexPersist({
  storage: window.sessionStorage,
  modules: ["user"]
});

export default new Vuex.Store({
  state: {
    activiteeConsultation: {},
    imagesUploaded: [],
    uploadInProgress: {},
    average: 0,
    activiteeStep1: {
      titre: "",
      description: "",
      fonctionsCognitives: "",
      typeTraitement: "bottom-up",
      materiel: "",
      duree: 0,
      proceduresUtilisees: "",
      nombreSeances: 0,
      trancheAge: "",
      typeIntervention: "individuelle",
      difficulte: ""
    },
    firebaseUser: {},
    activiteeStep2: {},
    activiteeStep3: {}
  },
  getters: {
    mesActivitees(state) {
      return state.activitees.filter(
        x => x.userId === firebase.auth().currentUser.uid
      );
    },
    mesActiviteesFavorites(state) {
      return state.activitees.filter(x => state.user.data.fav.includes(x.id));
    },
    activiteeConsultation(state) {
      return state.activiteeConsultation;
    },
    uploadInProgress(state) {
      return state.uploadInProgress;
    },
    activiteeStep1(state) {
      return state.activiteeStep1;
    },
    average(state) {
      return state.average;
    }
  },
  mutations: {
    SET_ACTIVITEE_CONSULTATION(state, data) {
      state.activiteeConsultation = data;
    },
    SET_ACTIVITEE(state, data) {
      state.activitee = data;
    },
    SET_ACTIVITEES(state, data) {
      state.activitees = data;
    },
    STEP_ACTIVITEE_1(state, data) {
      state.activiteeStep1 = data;
    },
    STEP_ACTIVITEE_2(state, data) {
      state.activiteeStep2 = data;
    },
    STEP_ACTIVITEE_3(state, data) {
      state.activiteeStep3 = data;
    },
    SET_ACTIVITEE_IMAGE(state, url, id) {
      const elementsIndex = this.state.activitees.findIndex(
        element => element.id == id
      );
      let newArray = [...this.state.activitees];
      newArray[elementsIndex] = { ...newArray[elementsIndex], mainMedia: url };
      state.activitees = newArray;
    },
    SET_TITRE_ACTIVITE_STEP_1(state, data) {
      state.activiteeStep1.titre = data;
    },
    SET_DESCRIPTION_ACTIVITE_STEP_1(state, data) {
      state.activiteeStep1.description = data;
    },
    SET_FONCTIONS_COGNITIVES_ACTIVITE_STEP_1(state, data) {
      state.activiteeStep1.fonctionsCognitives = data;
    },
    SET_TYPE_TRAITEMENT_ACTIVITE_STEP_1(state, data) {
      state.activiteeStep1.typeTraitement = data;
    },
    SET_MATERIEL_ACTIVITE_STEP_1(state, data) {
      state.activiteeStep1.materiel = data;
    },
    SET_DUREE_ACTIVITE_STEP_1(state, data) {
      state.activiteeStep1.duree = data;
    },
    SET_PROCEDURE_ACTIVITE_STEP_1(state, data) {
      state.activiteeStep1.proceduresUtilisees = data;
    },
    SET_NOMBRE_SEANCES_ACTIVITE_STEP_1(state, data) {
      state.activiteeStep1.nombreSeances = data;
    },
    SET_TRANCHE_AGE_ACTIVITE_STEP_1(state, data) {
      state.activiteeStep1.trancheAge = data;
    },
    SET_TYPE_INTERVENTION_ACTIVITE_STEP_1(state, data) {
      state.activiteeStep1.typeIntervention = data;
    },
    SET_DIFFICULTE_ACTIVITE_STEP_1(state, data) {
      state.activiteeStep1.difficulte = data;
    }
  },
  actions: {
    switchTextAreaFormat({ state, commit }) {
      const activitee = state.activiteeConsultation;
      activitee.materiel = activitee.materiel.replaceAll("<br />", "\n");

      commit("SET_ACTIVITEE_CONSULTATION", activitee);
    }
  },
  modules: {
    activities: ActivitiesModule,
    upload: UploadModule,
    user: UserModule
  },
  plugins: [vuexLocal.plugin]
});
